import { appWerklijstG4Fr } from './golf4App.fr.js';
// Frans (fr-FR), werklijstApp: zelfde vorm als werklijstApp.nl.ts (golf 3-integratie). Alleen de
// schermteksten; de punten zelf blijven Nederlands (docs/werklijst.json).
export const appWerklijstFr = {
    ...appWerklijstG4Fr,
    title: 'Liste de travail',
    subtitle: 'Seulement pour toi en tant qu’administrateur · mise à jour {when}',
    progress: '{done} sur {total} terminés',
    progressLabel: 'Progression : {done} points sur {total} terminés',
    progressRegion: 'Progression',
    status: {
        waiting_on_you: 'T’attend',
        in_progress: 'En cours',
        planned: 'Prévu',
        later: 'Plus tard',
        done: 'Terminé',
    },
    filterAll: 'Tout',
    filterLabel: 'Afficher',
    filterActive: 'Tu vois maintenant seulement : {status}',
    showAll: 'Tout afficher',
    needsYou: 'Ce dont j’ai besoin de ta part',
    needsYouCount: {
        one: 'Un point t’attend.',
        other: '{count} points t’attendent.',
    },
    show: 'Voir',
    doneAt: 'Terminé le {when}',
    whatIsIt: 'De quoi s’agit-il ?',
    yourAction: 'Que dois-tu faire ?',
    numberLabel: 'point {n} de tes retours',
    groupCount: '{done} sur {total} terminés',
    emptyTitle: 'Rien avec cet état',
    emptyBody: 'Choisis un autre état ci-dessus, ou Tout.',
    unavailable: 'La liste de travail est illisible pour l’instant. Réessaie plus tard.',
};
//# sourceMappingURL=werklijstApp.fr.js.map